import React from 'react';
import { Dispatch } from '@reduxjs/toolkit';

import { Category } from '../../../../interfaces/config/category.interface';

import { RemoveCategoryAction } from '../../../../actions/category/category.types';
import { CategoryActions } from '../../../../actions/category/category.actions';

import { useAppDispatch, useRemoval } from '../../../../hooks';

import { Modal } from '../../../../components/modal/Modal';
import { ModalLayout } from '../../../../components/modal/ModalLayout';
import RemoveModal from '../../../../components/modal/remove/RemoveModal';

const RemoveCategoryContainer = () => {
  const dispatch: Dispatch<RemoveCategoryAction> = useAppDispatch();

  const { element, showModal, setShowModal } = useRemoval();

  const onClose = () => setShowModal(false);

  const handleConfirm = (onComplete: () => void) => {
    dispatch(
      CategoryActions.removeCategory((element as Category).id as number, () => {
        onComplete();
        onClose();
      })
    );
  };

  return (
    <>
      {showModal && (
        <Modal>
          <ModalLayout onClose={onClose} title="Remove Category">
            <RemoveModal title={(element as Category).name} onConfirm={handleConfirm} />
          </ModalLayout>
        </Modal>
      )}
    </>
  );
};

export default RemoveCategoryContainer;
